export default __webpack_public_path__ + "static/media/k7.b7fe4090.jpg";